export default "__VITE_ASSET__ptSzp3ZM__"